import React from 'react';
import { COMPANY } from '../data/siteData';

const PrivacyPage = () => (
    <div className="page">
        <div className="container page-container">
            <h1 className="page-title">Политика конфиденциальности</h1>

            <div className="page-content legal-content">
                <p>
                    Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных
                    данных пользователей сайта {COMPANY.siteUrl} (далее — Сайт).
                </p>

                <h2>1. Оператор персональных данных</h2>
                <p>
                    Оператор персональных данных: ИНН {COMPANY.inn}, ОГРНИП {COMPANY.ogrn}, адрес:{' '}
                    {COMPANY.address}, e-mail: {COMPANY.email}.
                </p>

                <h2>2. Какие данные мы собираем</h2>
                <p>При заполнении формы заявки на Сайте мы можем получать следующие данные:</p>
                <ul>
                    <li>имя;</li>
                    <li>номер телефона;</li>
                    <li>город проживания;</li>
                    <li>выбранная вакансия (профессия).</li>
                </ul>
                <p>
                    Также автоматически могут собираться технические данные: IP-адрес, тип браузера, данные
                    cookies, сведения о посещении страниц (в том числе через сервис Яндекс.Метрика).
                </p>

                <h2>3. Цели обработки данных</h2>
                <ul>
                    <li>обработка заявки и обратная связь с соискателем;</li>
                    <li>консультация по вакансиям и условиям трудоустройства;</li>
                    <li>передача контактных данных партнёрам-работодателям для связи с соискателем;</li>
                    <li>улучшение работы Сайта и анализ посещаемости.</li>
                </ul>

                <h2>4. Правовые основания</h2>
                <p>
                    Обработка персональных данных осуществляется на основании согласия пользователя (ст. 6
                    Федерального закона № 152-ФЗ «О персональных данных»), а также в целях исполнения
                    договора об оказании информационных услуг.
                </p>

                <h2>5. Передача данных третьим лицам</h2>
                <p>
                    Мы можем передавать персональные данные партнёрским организациям — работодателям — для
                    связи с соискателем по заявке. Передача осуществляется только в объёме, необходимом для
                    достижения указанных целей.
                </p>

                <h2>6. Срок хранения</h2>
                <p>
                    Персональные данные хранятся не дольше, чем это необходимо для целей обработки, но не
                    более 3 лет с момента последнего обращения, если иное не предусмотрено законодательством.
                </p>

                <h2>7. Права пользователя</h2>
                <p>Вы имеете право:</p>
                <ul>
                    <li>получить информацию об обработке ваших персональных данных;</li>
                    <li>требовать уточнения, блокирования или удаления данных;</li>
                    <li>отозвать согласие на обработку персональных данных.</li>
                </ul>
                <p>
                    Для реализации прав направьте запрос на {COMPANY.email}.
                </p>

                <h2>8. Cookies и аналитика</h2>
                <p>
                    Сайт использует файлы cookies и сервис Яндекс.Метрика для анализа посещаемости. Вы можете
                    отключить cookies в настройках браузера, однако это может повлиять на работу Сайта.
                </p>

                <h2>9. Защита данных</h2>
                <p>
                    Оператор принимает необходимые организационные и технические меры для защиты персональных
                    данных от неправомерного доступа, уничтожения, изменения или распространения.
                </p>

                <h2>10. Изменения политики</h2>
                <p>
                    Оператор вправе вносить изменения в настоящую Политику. Актуальная версия всегда
                    доступна на данной странице.
                </p>

                <p className="page-note">Дата публикации: 23 июня 2026 г.</p>
            </div>
        </div>
    </div>
);

export default PrivacyPage;
